import React from 'react'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { list, find, save, remove, transferToInventory } from '../../services/draftInventory'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchDraftInventorysRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchDraftInventorys'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = null
    fe.orderBy = null
  } else {
    fe.searchTerm = null
    fe.orderBy = null
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_DRAFTINVENTORY,
    result,
  })
}

function* fetchDraftInventorys({ size, index, searchTerm, orderBy, date, inventoryNumber }) {
  console.log('fetchDraftInventorys', size, index, searchTerm, orderBy, date, inventoryNumber)
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('draftInventoryFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    date = date || parsedFilters.date || null
    inventoryNumber = inventoryNumber || parsedFilters.inventoryNumber || ''
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy, date, inventoryNumber)
  yield put({
    type: actions.LIST_DRAFTINVENTORY,
    result,
  })
}

function* fetchDraftInventoryEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  console.log('fetchDraftInventoryEdit', result)
  yield put({
    type: actions.EDIT_DRAFTINVENTORY,
    result,
    openModal,
  })
}

function* fetchDraftInventorySave(values) {
  yield put({
    type: actions.SAVING_DRAFTINVENTORY,
  })
  const result = yield call(save, values)
  // Success = ServiceResponse with status 1. A rejected save comes back as the server's
  // message text (400); null means the request helper has already shown the error.
  const ok = result !== null && typeof result === 'object' && result.status === 1
  if (ok) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  } else if (typeof result === 'string' && result !== '') {
    notification.error({ duration: 0, message: 'Error', description: result })
  }
  yield put({
    type: actions.SAVE_DRAFTINVENTORY_RECIEVED,
    ok,
  })
  if (ok) {
    yield put({
      type: actions.RE_FETCH_DRAFTINVENTORYS,
    })
  }
}

function* fetchDraftInventoryDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_DRAFTINVENTORY_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DRAFTINVENTORYS,
  })
}

function* fetchTransferToInventory({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(transferToInventory, id)
  console.log('fetchTransferToInventory', result)
  if (result.status === 1) {
    notification.success({ message: DEL_200_MSG, description: result.message, duration: 0 })
  } else {
    notification.error({
      duration: 0,
      description: <>{result.message}</>,
      message: 'Error',
    })
  }
  yield put({
    type: actions.TRANSFERTOINVENTORY_RECIEVED,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DRAFTINVENTORYS, fetchDraftInventorys),
    takeEvery(actions.FETCH_DRAFTINVENTORY, fetchDraftInventoryEdit),
    takeEvery(actions.SAVE_DRAFTINVENTORY, fetchDraftInventorySave),
    takeEvery(actions.DELETE_DRAFTINVENTORY, fetchDraftInventoryDelete),
    takeEvery(actions.RE_FETCH_DRAFTINVENTORYS, fetchDraftInventorysRefresh),
    takeEvery(actions.TRANSFERTOINVENTORY, fetchTransferToInventory),
  ])
}
